(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sectionId = '{{ section.id }}';
    const minDesktopWidth = 990;
    const cardsPerStep = 3; // 3 cartes par clic

    const initCollectionStep = (root) => {
      if (!root || window.innerWidth < minDesktopWidth) return;
      const slider = root.querySelector(`#Slider-${sectionId}`);
      const nextBtn = root.querySelector('[data-collection-jump="next"]');
      const prevBtn = root.querySelector('[data-collection-jump="prev"]');
      if (!slider || !nextBtn || !prevBtn) return;

      // Si déjà initialisé, ne pas réinitialiser
      if (nextBtn.dataset.collectionStepHandler === 'true') return;

      const getStepSize = () => {
        const firstItem = slider.querySelector('.collection-list__item');
        if (!firstItem) return slider.clientWidth / 3;
        const itemStyle = window.getComputedStyle(firstItem);
        const gap = parseFloat(itemStyle.marginRight || '0');
        const width = firstItem.getBoundingClientRect().width;
        return (width + gap) * cardsPerStep;
      };

      // Handler pour le bouton suivant
      const handleNext = (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        
        const stepSize = getStepSize();
        const maxScroll = slider.scrollWidth - slider.clientWidth;
        const targetScroll = Math.min(maxScroll, slider.scrollLeft + stepSize);
        slider.scrollTo({ left: targetScroll, behavior: 'smooth' });
      };

      // Handler pour le bouton précédent
      const handlePrev = (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        
        const stepSize = getStepSize();
        const targetScroll = Math.max(0, slider.scrollLeft - stepSize);
        slider.scrollTo({ left: targetScroll, behavior: 'smooth' });
      };

      // Remplacer complètement les handlers existants
      const newNextBtn = nextBtn.cloneNode(true);
      const newPrevBtn = prevBtn.cloneNode(true);
      
      newNextBtn.addEventListener('click', handleNext, { capture: true, passive: false });
      newPrevBtn.addEventListener('click', handlePrev, { capture: true, passive: false });
      
      nextBtn.replaceWith(newNextBtn);
      prevBtn.replaceWith(newPrevBtn);
      
      newNextBtn.dataset.collectionStepHandler = 'true';
      newPrevBtn.dataset.collectionStepHandler = 'true';
    };

    const loadHandler = () => {
      setTimeout(() => {
        const section = document.getElementById(`shopify-section-${sectionId}`);
        if (section) initCollectionStep(section);
      }, 500);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadHandler);
    } else {
      loadHandler();
    }
    
    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId === sectionId) {
        setTimeout(() => initCollectionStep(event.target), 500);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
